import React from "react";
import { useTranslation } from "react-i18next";

const btn = {
  display: "inline-block",
  backgroundColor: "#004c3f",
  color: "#fff",
  textDecoration: "none",
  padding: "10px 20px",
  borderRadius: 8,
  fontWeight: 600,
  marginRight: 10,
};

const NewsStoriesSection = () => {
  const { t } = useTranslation();
  return (
    <section id="news" style={{ padding: "60px 10%", backgroundColor: "#f7faf9" }}>
      <h2 style={{ fontSize: 26, fontWeight: 700, color: "#0a2750", marginBottom: 10 }}>
        {t("EmiratesMade.News.title", { defaultValue: "News & Success Stories" })}
      </h2>
      <p style={{ maxWidth: 900, color: "#222", lineHeight: 1.7, marginBottom: 18 }}>
        {t("EmiratesMade.News.text", { defaultValue: "Stay informed about the latest developments, achievements, and milestones from companies proudly carrying the Made in the Emirates label." })}
      </p>
      <div>
        <a href="#read-news" style={btn}>{t("EmiratesMade.News.cta1", { defaultValue: "Read Latest News" })}</a>
        <a href="#submit-story" style={{ ...btn, backgroundColor: "#0a2750" }}>{t("EmiratesMade.News.cta2", { defaultValue: "Submit Your Story" })}</a>
      </div>
    </section>
  );
};

export default NewsStoriesSection;

